
export type SchoolType = {
  name: string;
  value:
    | "kindergarden"
    | "primarySchool"
    | "juniorSchool"
    | "highSchool"
    | "university"
    | "studyAbroad";
};

export const childSchools: SchoolType[] = [
  {
    name: "幼稚園",
    value: "kindergarden",
  },
  {
    name: "小学校",
    value: "primarySchool",
  },
  {
    name: "中学校",
    value: "juniorSchool",
  },
  {
    name: "高校",
    value: "highSchool",
  },
  {
    name: "大学",
    value: "university",
  },
  {
    name: "留学",
    value: "studyAbroad",
  },
];

export const grade = [
  {
    name: "未就学児",
    value: "preschool",
  },
  {
    name: "幼稚園 年少",
    value: "kinder1",
  },
  {
    name: "幼稚園 年中",
    value: "kinder2",
  },
  {
    name: "幼稚園 年長",
    value: "kinder3",
  },
  {
    name: "小学校１年生",
    value: "primary1",
  },
  {
    name: "小学校２年生",
    value: "primary2",
  },
  {
    name: "小学校３年生",
    value: "primary3",
  },
  {
    name: "小学校４年生",
    value: "primary4",
  },
  {
    name: "小学校５年生",
    value: "primary5",
  },
  {
    name: "小学校６年生",
    value: "primary6",
  },
  {
    name: "中学校１年生",
    value: "junior1",
  },
  {
    name: "中学校２年生",
    value: "junior2",
  },
  {
    name: "中学校３年生",
    value: "junior3",
  },
  {
    name: "高校１年生",
    value: "high1",
  },
  {
    name: "高校２年生",
    value: "high2",
  },
  {
    name: "高校３年生",
    value: "high3",
  },
  {
    name: "大学１年生",
    value: "uni1",
  },
  {
    name: "大学２年生",
    value: "uni2",
  },
  {
    name: "大学３年生",
    value: "uni3",
  },
  {
    name: "大学４年生",
    value: "uni4",
  },
];

export const relationships = [
  {
    display: "母親",
    value: "mother",
  },
  {
    display: "父親",
    value: "father",
  },
  {
    display: "親族ほか",
    value: "other",
  },
];

export const gender = [
  {
    display: "女",
    value: "female",
  },
  {
    display: "男",
    value: "male",
  },
  {
    display: "無回答",
    value: "NA",
  },
];
export const schoolType = [
  {
    name: "国公立",
    value: "public",
  },
  {
    name: "私立",
    value: "private",
  },
];

export const universityType = [
  {
    name: "国公立（文系・理系含む）",
    value: "national_public",
  },
  {
    name: "私立（文系）",
    value: "private_liberalart",
  },
  {
    name: "私立（理系）",
    value: "private_science",
  },
  {
    name: "国立（医学・薬学系）",
    value: "national_medical_pharmaceutical",
  },
  {
    name: "私立（医学系）",
    value: "private_medical",
  },
  {
    name: "私立（薬学系）",
    value: "private_pharmaceutical",
  },
];

export const studyAbroadType = [
  {
    name: "計算に含めない",
    value: "NA",
  },
  {
    name: "短期留学/3ヶ月",
    value: "short",
  },
  {
    name: "中期留学/6ヶ月",
    value: "middle",
  },
  {
    name: "長期留学/1年",
    value: "long",
  },
];

export const isChildrenSection = [
  {
    no: "1",
    title: "あなたのこと",
  },
  {
    no: "2",
    title: "パートナー・配偶者のこと",
  },
  {
    no: "3",
    title: "子どものこと",
  },
  {
    no: "4",
    title: "興味・関心",
  },
];

export const isNotChildrenSection = [
  {
    no: "1",
    title: "あなたのこと",
  },
  {
    no: "2",
    title: "パートナー・配偶者のこと",
  },
  {
    no: "3",
    title: "興味・関心",
  },
];

export const userTopic = [
  {
    id: "1",
    name: "節約",
    isSelected: false,
    value: "0",
  },
  {
    id: "2",
    name: "貯金",
    isSelected: false,
    value: "0",
  },
  {
    id: "3",
    name: "NISA",
    isSelected: false,
    value: "0",
  },
  {
    id: "4",
    name: "iDeCo",
    isSelected: false,
    value: "0",
  },
  {
    id: "5",
    name: "資産運用（株式）",
    isSelected: false,
    value: "0",
  },
  {
    id: "6",
    name: "確定拠出年金（4false1K）",
    isSelected: false,
    value: "0",
  },
  {
    id: "7",
    name: "ねんきん定期便",
    isSelected: false,
    value: "0",
  },
  {
    id: "8",
    name: "医療保険・介護保険",
    isSelected: false,
    value: "0",
  },
  {
    id: "9",
    name: "損害保険",
    isSelected: false,
    value: "0",
  },
  {
    id: "10",
    name: "生命保険",
    isSelected: false,
    value: "0",
  },
  {
    id: "11",
    name: "相続・贈与",
    isSelected: false,
    value: "0",
  },
  {
    id: "12",
    name: "ライフプランニング",
    isSelected: false,
    value: "0",
  },
];

export const childItem = [
  {
    id: "child1",
    name: "少し興味がある",
    value: "1",
  },
  {
    id: "child2",
    name: "興味がある",
    value: "2",
  },
  {
    id: "child3",
    name: "大変興味がある",
    value: "3",
  },
];

// 無理やりだが、現在のgrade（primary1など）から今後の進学予定先を配列で返却
export const getSchoolPlan = (arg: string, offset?: number) => {
  let index = -1;
  const target = arg.replace(/[1-9]/, "");
  childSchools.find((s, i) => {
    if (s.value.startsWith(target)) {
      index = i;
      return true;
    }
  });

  if (offset != null) {
    index += offset;
  }

  index += 1;
  if (index < 0) {
    index = 0;
  }

  return childSchools.slice(index, childSchools.length);
};